import React, { useEffect, useState } from 'react'
import {
  Accordion, AccordionDetails, AccordionSummary,
  Grid, Input, NativeSelect, Paper, Typography
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import Header from '../../../layout/Header'
import Subheader from '../../../layout/Subheader'
import Loading from '../../../components/Loading'
import api from '../../../services/api'
import { findPermission } from '../../../services/auth'
import { useMessageBox } from '../../../context/MessageBox'

import useStyles from './style'
import LayoutCnabAccordion from './components/LayoutCnabAccordion'

export const MODULO_ID_BANCOS_REMESSAS = 11120

const TIPO_PAGAMENTO_OPTIONS = [
  { value: 'TED', label: 'TED' },
  { value: 'PIX', label: 'PIX' },
]
const TIPO_LAYOUT_OPTIONS = [
  { value: 'CNAB240', label: 'CNAB 240' },
  { value: 'CNAB400', label: 'CNAB 400' },
]
const STATUS_OPTIONS = [
  { value: 'Ativo', label: 'Ativo' },
  { value: 'Inativo', label: 'Inativo' },
]

const EMPTY_FORM = {
  bancoRemessaId: 0,
  bancoId: '',
  nome: '',
  razaoSocialCedente: '',
  cnpj: '',
  agencia: '',
  conta: '',
  dac: '',
  tipoPagamento: 'TED',
  tipoLayout: 'CNAB240',
  versaoLayout: '',
  subDiretorio: '',
  diretorioEnvioVan: '',
  diretorioRetornoVan: '',
  status: 'Ativo',
  dataAtualizacao: '',
}

export function BancoRemessaRegister () {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()
  const { id } = useParams()
  const { setMessageData } = useMessageBox()

  const isVisualize = location.pathname.endsWith('/visualizar')
  const isEdit = !!id && !isVisualize
  const isRegister = !id
  const canAlterar = !!findPermission(MODULO_ID_BANCOS_REMESSAS, 'Alterar')
  const canCadastrar = !!findPermission(MODULO_ID_BANCOS_REMESSAS, 'Cadastrar')
  const readOnly = isVisualize || (isEdit && !canAlterar) || (isRegister && !canCadastrar)

  const [isLoading, setLoading] = useState(true)
  const [formValues, setFormValues] = useState(EMPTY_FORM)
  const [bancos, setBancos] = useState([])

  useEffect(() => {
    if (!findPermission(MODULO_ID_BANCOS_REMESSAS, 'Consultar')) {
      history.replace('/app/home')
    }
  }, [history])

  useEffect(() => {
    (async () => {
      try {
        const bancosRes = await api.get('Bancos/Consultar?status=Ativo')
        setBancos(bancosRes?.data?.resposta || [])

        if (id) {
          const res = await api.get(`BancosRemessas/ConsultarId?id=${id}`)
          if (res?.data?.complemento?.mensagensBox?.length > 0) {
            setMessageData(res.data.complemento.mensagensBox)
          }
          if (res?.data?.status === 'Sucesso' && res?.data?.resposta) {
            const r = res.data.resposta
            setFormValues({
              bancoRemessaId: r.bancoRemessaId,
              bancoId: r.bancoId || '',
              nome: r.nome || '',
              razaoSocialCedente: r.razaoSocialCedente || '',
              cnpj: r.cnpj || '',
              agencia: r.agencia || '',
              conta: r.conta || '',
              dac: r.dac || '',
              tipoPagamento: r.tipoPagamento || 'TED',
              tipoLayout: r.tipoLayout || 'CNAB240',
              versaoLayout: r.versaoLayout || '',
              subDiretorio: r.subDiretorio || '',
              diretorioEnvioVan: r.diretorioEnvioVan || '',
              diretorioRetornoVan: r.diretorioRetornoVan || '',
              status: r.status || 'Ativo',
              dataAtualizacao: r.dataAtualizacao || '',
            })
          } else {
            toast.error('Banco Remessa não encontrado.')
            history.push('/app/bancos-remessas')
            return
          }
        }
      } catch (err) {
        toast.error('Erro ao carregar dados.')
      } finally {
        setLoading(false)
      }
    })()
  }, [id])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormValues((prev) => ({ ...prev, [name]: value }))
  }

  const buildPayload = () => ({
    bancoId: Number(formValues.bancoId),
    nome: formValues.nome,
    razaoSocialCedente: formValues.razaoSocialCedente,
    cnpj: formValues.cnpj.replace(/\D/g, ''),
    agencia: formValues.agencia,
    conta: formValues.conta,
    dac: formValues.dac,
    tipoPagamento: formValues.tipoPagamento,
    tipoLayout: formValues.tipoLayout,
    versaoLayout: formValues.versaoLayout,
    subDiretorio: formValues.subDiretorio || '',
    diretorioEnvioVan: formValues.diretorioEnvioVan || '',
    diretorioRetornoVan: formValues.diretorioRetornoVan || '',
    status: formValues.status,
  })

  const onSubmit = async () => {
    if (readOnly) return

    if (!formValues.bancoId || !formValues.nome || !formValues.razaoSocialCedente || !formValues.cnpj || !formValues.agencia || !formValues.conta || !formValues.dac || !formValues.versaoLayout) {
      toast.error('Preencha todos os campos obrigatórios.')
      return
    }

    setLoading(true)
    try {
      let res
      if (isRegister) {
        res = await api.post('BancosRemessas', buildPayload())
      } else {
        res = await api.put('BancosRemessas', {
          ...buildPayload(),
          bancoRemessaId: Number(id),
          dataAtualizacao: formValues.dataAtualizacao,
        })
      }

      if (res?.data?.complemento?.mensagensBox?.length > 0) {
        setMessageData(res.data.complemento.mensagensBox)
      }

      if (res?.data?.status !== 'Sucesso') {
        const erros = res?.data?.resposta || []
        if (erros.length > 0) {
          erros.forEach((e) => toast.error(e.message))
        } else {
          toast.error('Erro ao salvar.')
        }
        return
      }

      toast.success(isRegister ? 'Banco Remessa cadastrado com sucesso!' : 'Banco Remessa atualizado com sucesso!')

      if (isRegister && res.data.resposta?.bancoRemessaId) {
        history.push(`/app/bancos-remessas/${res.data.resposta.bancoRemessaId}/editar`)
      } else if (res.data.resposta?.dataAtualizacao) {
        setFormValues((prev) => ({ ...prev, dataAtualizacao: res.data.resposta.dataAtualizacao }))
      }
    } catch (err) {
      const msg = err?.response?.data?.resposta?.[0]?.message
      toast.error(msg || 'Erro ao salvar.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={classes.root}>
      <Header />
      <Subheader
        title={isRegister ? 'Novo Banco Remessa' : (isVisualize ? 'Visualizar Banco Remessa' : 'Editar Banco Remessa')}
        back="/app/bancos-remessas"
        submit={readOnly ? undefined : onSubmit}
        submitText="Salvar"
        loading={isLoading}
      />
      <div className={classes.content}>
        <div className={classes.rootForm}>
          {isLoading ? (
            <Loading />
          ) : (
            <>
              <Accordion defaultExpanded className={classes.accordionRoot}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                  <Typography className={classes.heading}>Dados Gerais</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container spacing={2}>
                    <Grid item xs={3} className={classes.item}>
                      <label className={classes.label}>Banco *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          name="bancoId"
                          value={formValues.bancoId}
                          onChange={handleChange}
                          disabled={readOnly}
                          style={{ width: '100%' }}
                        >
                          <option value="">Selecione</option>
                          {bancos.map((b) => (
                            <option key={b.bancoId} value={b.bancoId}>
                              {b.banco}
                            </option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={5} className={classes.item}>
                      <label className={classes.label}>Apelido (exibição) *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="nome"
                          value={formValues.nome}
                          onChange={handleChange}
                          readOnly={readOnly}
                          inputProps={{ maxLength: 100 }}
                          placeholder="Ex.: Itaú PIX"
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={4} className={classes.item}>
                      <label className={classes.label}>CNPJ do Cedente * (14 dígitos)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="cnpj"
                          value={formValues.cnpj}
                          onChange={(e) =>
                            setFormValues((prev) => ({ ...prev, cnpj: e.target.value.replace(/\D/g, '') }))
                          }
                          readOnly={readOnly}
                          inputProps={{ maxLength: 14 }}
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={9} className={classes.item}>
                      <label className={classes.label}>Razão Social do Cedente * (vai no CNAB pos 73)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="razaoSocialCedente"
                          value={formValues.razaoSocialCedente}
                          onChange={handleChange}
                          readOnly={readOnly}
                          inputProps={{ maxLength: 60 }}
                          placeholder="Razão social da empresa titular da conta"
                        />
                      </Paper>
                    </Grid>

                    <Grid item xs={3} className={classes.item}>
                      <label className={classes.label}>Agência Cedente *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="agencia"
                          value={formValues.agencia}
                          onChange={handleChange}
                          readOnly={readOnly}
                          inputProps={{ maxLength: 10 }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={4} className={classes.item}>
                      <label className={classes.label}>Conta Cedente *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="conta"
                          value={formValues.conta}
                          onChange={handleChange}
                          readOnly={readOnly}
                          inputProps={{ maxLength: 20 }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={2} className={classes.item}>
                      <label className={classes.label}>DAC *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="dac"
                          value={formValues.dac}
                          onChange={handleChange}
                          readOnly={readOnly}
                          inputProps={{ maxLength: 2 }}
                        />
                      </Paper>
                    </Grid>
                    <Grid item xs={3} className={classes.item}>
                      <label className={classes.label}>Status</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          name="status"
                          value={formValues.status}
                          onChange={handleChange}
                          disabled={readOnly}
                          style={{ width: '100%' }}
                        >
                          {STATUS_OPTIONS.map((s) => (
                            <option key={s.value} value={s.value}>{s.label}</option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>

                    <Grid item xs={4} className={classes.item}>
                      <label className={classes.label}>Tipo de Pagamento *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          name="tipoPagamento"
                          value={formValues.tipoPagamento}
                          onChange={handleChange}
                          disabled={readOnly}
                          style={{ width: '100%' }}
                        >
                          {TIPO_PAGAMENTO_OPTIONS.map((t) => (
                            <option key={t.value} value={t.value}>{t.label}</option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={4} className={classes.item}>
                      <label className={classes.label}>Tipo de Layout *</label>
                      <Paper className={classes.medium} elevation={0}>
                        <NativeSelect
                          className={classes.input}
                          name="tipoLayout"
                          value={formValues.tipoLayout}
                          onChange={handleChange}
                          disabled={readOnly}
                          style={{ width: '100%' }}
                        >
                          {TIPO_LAYOUT_OPTIONS.map((t) => (
                            <option key={t.value} value={t.value}>{t.label}</option>
                          ))}
                        </NativeSelect>
                      </Paper>
                    </Grid>
                    <Grid item xs={4} className={classes.item}>
                      <label className={classes.label}>Versão Layout * (ex: 085)</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="versaoLayout"
                          value={formValues.versaoLayout}
                          onChange={handleChange}
                          readOnly={readOnly}
                          inputProps={{ maxLength: 10 }}
                        />
                      </Paper>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <Accordion defaultExpanded className={classes.accordionRoot}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />} className={classes.summary}>
                  <Typography className={classes.heading}>Parâmetros de Diretório</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.details}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} className={classes.item}>
                      <label className={classes.label}>Subdiretório</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="subDiretorio"
                          value={formValues.subDiretorio}
                          onChange={handleChange}
                          readOnly={readOnly}
                          placeholder="ex: Itau\"
                          inputProps={{ maxLength: 100 }}
                          style={{ textTransform: 'none' }}
                        />
                      </Paper>
                      <div className={classes.helperText}>
                        Caminho interno de envio:&nbsp;
                        <code>{`<DIRETORIO_RAIZ_REMESSAS_ENVIO>${formValues.subDiretorio || ''}`}</code>
                        <br />
                        Caminho interno de retorno:&nbsp;
                        <code>{`<DIRETORIO_RAIZ_REMESSAS_RETORNO>${formValues.subDiretorio || ''}`}</code>
                        <br />
                        <em>As raízes internas são configuradas em Parâmetros do Sistema (167/168). Os caminhos da VAN (transmissão externa) são configurados abaixo.</em>
                      </div>
                    </Grid>
                    <Grid item xs={12} className={classes.item}>
                      <label className={classes.label}>Diretório de envio da VAN</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="diretorioEnvioVan"
                          value={formValues.diretorioEnvioVan}
                          onChange={handleChange}
                          readOnly={readOnly}
                          placeholder="ex: \\itau\sispag\envio"
                          inputProps={{ maxLength: 500 }}
                          style={{ textTransform: 'none' }}
                        />
                      </Paper>
                      <div className={classes.helperText}>
                        Pasta raiz onde o REM deste banco é copiado para transmissão (flat — sem subdiretório).
                      </div>
                    </Grid>
                    <Grid item xs={12} className={classes.item}>
                      <label className={classes.label}>Diretório de retorno da VAN</label>
                      <Paper className={classes.medium} elevation={0}>
                        <Input
                          className={classes.input}
                          name="diretorioRetornoVan"
                          value={formValues.diretorioRetornoVan}
                          onChange={handleChange}
                          readOnly={readOnly}
                          placeholder="ex: \\itau\sispag\retorno"
                          inputProps={{ maxLength: 500 }}
                          style={{ textTransform: 'none' }}
                        />
                      </Paper>
                      <div className={classes.helperText}>
                        Pasta raiz onde a rotina procura RET deste banco. Vazio = usa a pasta interna (168) como fallback (modo dev/local).
                      </div>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <LayoutCnabAccordion
                bancoRemessaId={Number(formValues.bancoRemessaId) || 0}
                readOnly={readOnly}
                classes={classes}
              />
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default BancoRemessaRegister
